<label class="wrapper" #label [ngClass]="{
    'disabled': disabled
}">
    <input
        class="input kk-visuallyhidden"
        type="radio"
        [formControl]="formControl"
        [name]="control | controlToKeyName"
        [value]="value"
        [checked]="checked"
        (click)="handleClick($event)"
    />
    <div class="content">
        <span class="background" [ngClass]="{ 'background-animate': !firstChange }" [ngStyle]="style"></span>
        <span class="text">
            <ng-content></ng-content>
        </span>
    </div>
</label>
